import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMortyMonogram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="#fff"
      d="M13.323 14V0h-2.874L6.664 9.997 2.88 0H0v14h2.378V5.743L5.688 14h1.849l3.31-8.257V14z"
    />
  </svg>
);
export default SvgMortyMonogram;
